import {setProjectSaveResultFromBackend} from "../store/makerDataSlice";
import axios from "axios";
import {saveProjectUrl} from "./url";
import {prepareData} from "./prepareData";

export default async function saveProject2(argsData: any) {

    let makerData = argsData.makerData;
    let dispatch = argsData.dispatch;

    const data = prepareData(makerData, dispatch);

    let vkLaunchParams = {};
    if (makerData?.vkLaunchParams?.vk_app_id) {
        for (const [key, value] of Object.entries(makerData.vkLaunchParams)) {
            // @ts-ignore
            vkLaunchParams[key] = value;
        }
    }

    const response = await axios.post(
        saveProjectUrl,
        data,
        {
            params: vkLaunchParams,
        }
    );
    if (response.data.result == 'ok' || response.data.result == 'ok_2') {
        dispatch(setProjectSaveResultFromBackend(response.data));
        // if (response.data.showUrl !== undefined) {
        //localStorage.removeItem(LOCALSTORAGE_KEY);
        //window.open(response.data.showUrl,"_self");
        // }
        return response.data;
    } else {
        throw ({
            message: 'Failed to save project. Error in response.',
            response: response,
            responseConfig: JSON.stringify(response?.config),
            responseData: JSON.stringify(response?.data),
            url: saveProjectUrl
        });
    }
}